import { render, staticRenderFns } from "./TrafficBoost.vue?vue&type=template&id=14925364&scoped=true&"
import script from "./TrafficBoost.vue?vue&type=script&lang=js&"
export * from "./TrafficBoost.vue?vue&type=script&lang=js&"
import style0 from "./TrafficBoost.vue?vue&type=style&index=0&id=14925364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14925364",
  null
  
)

export default component.exports